// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1dM8V","list":"styles_list__ed_h7"};